export function humanizeTelegramError(raw: string): string {
	const lower = raw.toLowerCase();
	if (lower.includes("status 401") || lower.includes("unauthorized")) {
		return "Bot token is invalid. Create a new one in @BotFather.";
	}
	if (lower.includes("chat not found")) {
		return "The bot hasn't joined that chat yet. Add it to the chat, then try again.";
	}
	if (lower.includes("bot was blocked") || lower.includes("forbidden")) {
		return "This chat blocked the bot. Unblock it, or use a different chat.";
	}
	if (lower.includes("status 429") || lower.includes("too many")) {
		return "Telegram is rate-limiting. Wait a minute and try again.";
	}
	return raw.trim().length > 0
		? `Telegram rejected the request: ${raw}`
		: "Telegram rejected the request.";
}
